import { ACTION_SUBJECT_PREFIX } from '../../constants/analytics';
import { type ProductKeys, is3pProductKey } from '../../constants/products';
import { type FireAnalyticsEvent } from '../../types';

import { type CommonAttributes, type NonPrivacySafeAttributes } from './types';

type ProductOptionClickedArgs = {
	commonAttributes: CommonAttributes;
	nonPrivacySafeAttributes: NonPrivacySafeAttributes;
	isProductCurrentlySelected: boolean;
	productKey: ProductKeys | undefined;
	datasourceId?: string;
};

export const onAppFilterOptionClicked = ({
	commonAttributes,
	nonPrivacySafeAttributes,
	isProductCurrentlySelected,
	productKey,
	datasourceId,
}: ProductOptionClickedArgs): FireAnalyticsEvent => ({
	eventType: 'ui',
	actionSubject: 'button',
	actionSubjectId: `${ACTION_SUBJECT_PREFIX}RightPanelAppFilter`,
	action: 'clicked',
	attributes: {
		additionalAttributes: {
			productKey: productKey ?? 'all',
			...(datasourceId && { datasourceId }),
			is3pProduct: productKey ? is3pProductKey(productKey) : false,
			isProductCurrentlySelected: isProductCurrentlySelected ?? false,
		},
		commonAttributes,
	},
	nonPrivacySafeAttributes,
});
